const drawers = {
	defaultDrawerRef: null,
	wideDrawerRef: null,
};

const setDefaultDrawerRef = ref => (drawers.defaultDrawerRef = ref);
const getDefaultDrawer = () => drawers.defaultDrawerRef;
const setWideDrawerRef = ref => (drawers.wideDrawerRef = ref);
const getWideDrawer = () => drawers.wideDrawerRef;

export {
	setDefaultDrawerRef,
	getDefaultDrawer,
	setWideDrawerRef,
	getWideDrawer,
}